module.exports = __webpack_public_path__ + "img/Hoplite64_ua.438698a1.webp";